import { render, staticRenderFns } from "./Lgx02887700413887576801683.vue?vue&type=template&id=04efb9e6&scoped=true&"
import script from "./Lgx02887700413887576801683.vue?vue&type=script&lang=js&"
export * from "./Lgx02887700413887576801683.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02887700413887576801683.vue?vue&type=style&index=0&id=04efb9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efb9e6",
  null
  
)

export default component.exports